<header>
  <img src="/assets/lotta-logo.svg" alt="logo">
  <button mat-icon-button (click)="openNavigation()">
    <mat-icon>menu</mat-icon>
  </button>
</header>